import { useState, useContext, useCallback } from "react";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import {
  createCartaCorrecao,
  downloadCartaCorrecao,
  findCartasCorrecoes,
  sendCartaCorrecao,
} from "../../../../repositories/qerpapi/erp/nf/v1/CartaCorrecaoRepository";
import {
  cancelarNota,
  downloadArchives,
  downloadDanfe,
  downloadXmlNota,
  findNotas,
  sendMail,
} from "../../../../repositories/qerpapi/erp/nf/v1/NotafiscalRepository";
import {
  findUnusableNumbers,
  saveNumber,
  sendNumbers,
} from "../../../../repositories/qerpapi/erp/nf/v1/NumeroInutilizadoRepository";
import { aprovarLotePorNumeroNotaFiscal } from "../../../../repositories/qerpapi/erp/nf/v1/NFELoteNfRepository";
import { b64toBlob } from "../../../../utils/file64toBlob";
import instantDownload from "../../../../utils/InstantDownload";
import MaskService from "../../../../utils/mask/maskService";
import { find } from "../../../../repositories/qerpapi/erp/RouteRepository";

import { notify } from "../../../../utils/notify";
import { validNotNull } from "../../../../utils/validations";
import { PainelNfeContext } from "../contexts/PainelNfeContext";
import { findSituacaoVendas } from "../../../../repositories/qerpapi/erp/vendas/v1/VendasRepository";
import Swal from "sweetalert2";
import { useHistory } from "react-router";
import {
  duplicatePrint,
  getDuplicate,
} from "../../../../repositories/qerpapi/v3/screens-repositories/painel-nfe";
import { getCrBankBillet } from "../../../../repositories/qerpapi/v3/conta/receber";

export default function useNfeController() {
  const { push } = useHistory();
  const { queryParams } = useContext(QueryParamsContext);

  const {
    optionsStatus,
    cfop,
    receiver,
    numberNfe,
    setSelectedItem,
    iniDate,
    finallyDate,
    setQueryWhere,
    setQueryBetween,
    ccDescription,
    setCcError,
    setCCId,
    initialNumber,
    finalNumber,
    justify,
    series,
    setSeries,
    setInitialNumber,
    setFinalNumber,
    setInutError,
    setJustify,
    listSeries,
    filterSeries,
    typeNfe,
    accesKey,
    downloadXml,
    downloadDanfePdf,
    downloadCCe,
    setMainLoading,
    singleFolder,
    downloadXmlReturn,
    hasCanceled,
    hasSalesInNfe,
    saleSituation,
    model,
    selectedItem,
    setTabIndexUnunsed,
    filterModel,
  } = useContext(PainelNfeContext);

  const [loading, setLoading] = useState(false);

  const handleGetDataTable = () => {
    if (!filterModel?.value)
      return notify("Selecione um modelo para continuar.");

    setLoading(true);

    setSelectedItem([]);
    let where = {
      idempresa: parseInt(queryParams.id),
      modelo: filterModel?.value,
      tipo: typeNfe ? "S" : "E",
      indicadoremitente: "P",
    };

    if (optionsStatus?.value) where["status"] = optionsStatus.value;
    if (accesKey) where["chaveacesso"] = accesKey;
    if (cfop) where["cfop"] = cfop;
    if (receiver) where["nome"] = receiver;
    if (filterSeries) where["serie"] = filterSeries.serieNumber;
    if (numberNfe) where["numero"] = numberNfe;

    const between = `filter[between]=dataemissao,${iniDate},${finallyDate}`;

    setQueryWhere(where);
    setQueryBetween(accesKey || numberNfe ? "" : between);

    setLoading(false);
  };

  const handleDownloadDanfe = async (nfeId, download = false, type = 0) => {
    try {
      setMainLoading(true);
      const callbackDanfe = await downloadDanfe(
        queryParams.empresa_cnpj,
        nfeId,
        {
          tipo: type,
        }
      );

      if (!callbackDanfe.success)
        return notify("Erro Ao Fazer Download Da Danfe!");

      if (download) {
        const file = callbackDanfe.data;

        var element = document.createElement("a");
        element.setAttribute(
          "href",
          "data:application/octet-stream;base64," +
            encodeURIComponent(
              file.substring(file.split("").findIndex((e) => e === ",") + 1)
            )
        );
        element.setAttribute("download", `NFE-${nfeId}.pdf`);
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);

        return true;
      } else {
        const blob = b64toBlob(callbackDanfe.data, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleDownloadMultiplesDanfes = (
    selectedNotes = [],
    download = false,
    type = 0
  ) => {
    selectedNotes.forEach((note) => {
      handleDownloadDanfe(note.id, download, type);
    });
  };

  const handleCancelNfe = async (
    nfeIdProp,
    motivo,
    situation = {},
    emissao = false,
    setMainLoading = () => {},
    setNfeStatus = () => {},
    setModal = () => {}
  ) => {
    const retorno = await findNotas(
      queryParams.empresa_cnpj,
      nfeIdProp,
      "vendas.situacao"
    );

    var idSituation = retorno?.data?.vendas?.[0]?.idsituacao;
    if (idSituation) {
      const listaSituacoes = await findSituacaoVendas({
        empresa_cnpj: queryParams.empresa_cnpj,
        id: idSituation,
      });
      idSituation = listaSituacoes?.data?.idsituacaovendas_nf_cancelar ?? "";
    }

    setMainLoading(true);
    try {
      const body = {
        notafiscal: {
          xjust: motivo,
          situation: idSituation ?? "",
        },
      };
      const callbackCancel = await cancelarNota(
        queryParams.empresa_cnpj,
        nfeIdProp,
        body
      );

      if (!callbackCancel || !callbackCancel.success) {
        return Swal.fire({
          title: "Erro ao Cancelar a Nota",
          icon: "error",
          text: callbackCancel.message,
          showConfirmButton: true,
          confirmButtonText: "OK",
        });
      }

      if (emissao) {
        const callbackNfe = await findNotas(
          queryParams.empresa_cnpj,
          nfeIdProp
        );

        console.debug(callbackNfe);

        if (!callbackNfe.success) return;

        setNfeStatus(callbackNfe.data.status);
      }

      setModal(false);
      return notify("Nota Fiscal Cancelada com sucesso! ", true, "success");
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleDownloadXmlNota = async (
    nfeIdsProp = [],
    setLoading = () => {}
  ) => {
    try {
      setLoading(true);
      const callback = await downloadXmlNota(
        queryParams.empresa_cnpj,
        nfeIdsProp
      );

      if (!callback.success) return notify("Erro ao Fazer Download da Nota");

      const file = callback.data.archive_base64;

      var element = document.createElement("a");

      element.setAttribute(
        "href",
        "data:application/octet-stream;base64," +
          encodeURIComponent(
            file.substring(file.split("").findIndex((e) => e === ",") + 1)
          )
      );

      element.setAttribute("download", `NFeXML.zip`);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);

      return true;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveCC = async (nfeIdProp, description) => {
    const validateCC = validNotNull([
      {
        key: "ccDescription",
        value: ccDescription,
      },
    ]);

    setCcError(validateCC.errorsValidation);
    if (validateCC.error) {
      return notify("Preencha o Campo de Descrição !");
    }

    setMainLoading(true);

    try {
      const callbackExistsCC = await findCartasCorrecoes(
        queryParams.empresa_cnpj,
        "",
        {
          id_notafiscal: nfeIdProp,
        }
      );

      if (!callbackExistsCC.success) {
        return;
      }

      let ccNum = callbackExistsCC.data.length;
      ccNum++;

      const body = {
        cartacorrecao: {
          id_notafiscal: nfeIdProp,
          descricao: description,
          numero: ccNum,
        },
      };

      const callbackCC = await createCartaCorrecao(
        queryParams.empresa_cnpj,
        body
      );

      if (!callbackCC.success) {
        return notify("Erro ao Salvar Carta de Correção");
      }

      notify(
        "Carta de Correção Salva Com Sucesso. Transmitindo...",
        true,
        "success"
      );

      const callbackSendCC = await sendCartaCorrecao(
        queryParams.empresa_cnpj,
        callbackCC.data.id,
        body
      );

      if (!callbackSendCC.success) return notify(callbackSendCC.message);

      notify("Carta de Correção Enviada a Sefaz com Sucesso", true, "success");
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleHistoryCC = async (nfeIdProp, setViewLoading) => {
    if (nfeIdProp) {
      setViewLoading(true);
      try {
        const callbackHistoryCC = await findCartasCorrecoes(
          queryParams.empresa_cnpj,
          "",
          {
            id_notafiscal: nfeIdProp,
          },
          "numero"
        );

        if (!callbackHistoryCC.success) return;

        if (callbackHistoryCC.data.length) {
          setCCId(
            callbackHistoryCC.data[callbackHistoryCC.data.length - 1]?.id
          );
        }

        return callbackHistoryCC.data;
      } catch (error) {
        console.error(error);
      } finally {
        setViewLoading(false);
      }
    }
  };

  const handleSendEmail = async (
    nfeId,
    setViewLoading,
    mails,
    types,
    crMailArchives,
    setModal
  ) => {
    if (!mails.length) {
      return notify("Nenhum Email Informado.");
    }

    if (!types.length) {
      return notify("Selecione ao menos um tipo de arquivo a ser anexado.");
    }

    try {
      setViewLoading(true);

      const body = {
        ids: [nfeId],
        types: types,
        emails: mails,
        cc: [],
        crMailArchives,
      };

      const callback = await sendMail(queryParams.empresa_cnpj, body);

      if (!callback.success) {
        return notify("Erro ao Enviar Emails.");
      }

      setModal(false);
      return notify("Email(s) enviados com sucesso.", true, "success");
    } catch (error) {
      console.error(error);
    } finally {
      setViewLoading(false);
    }
  };

  const handleDownloadCartaCorrecao = async (ccId) => {
    try {
      setMainLoading(true);
      const downloadCC = await downloadCartaCorrecao(
        queryParams.empresa_cnpj,
        ccId
      );

      if (!downloadCC?.success || !downloadCC?.data)
        return notify("Falha ao Fazer Download da Carta de Correção.");

      const file = downloadCC.data;

      var element = document.createElement("a");

      element.setAttribute(
        "href",
        "data:application/octet-stream;base64," +
          encodeURIComponent(
            file.substring(file.split("").findIndex((e) => e === ",") + 1)
          )
      );

      element.setAttribute("download", `NfeCC.pdf`);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);

      return true;
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleInutilizarNumNfe = async (selectedNotes = []) => {
    try {
      let single = selectedNotes.length ? true : false;

      const arrValid = [
        {
          key: "justify",
          value: justify,
        },
        {
          key: "model",
          value: model,
        },
      ];

      if (hasSalesInNfe) {
        arrValid.push({
          key: "saleSituation",
          value: saleSituation,
        });
      }

      if (!single) {
        arrValid.push({
          key: "series",
          value: series?.serieNumber,
        });
        arrValid.push({
          key: "initialNumber",
          value: initialNumber,
        });
        arrValid.push({
          key: "finalNumber",
          value: finalNumber,
        });
      }

      const validateInut = validNotNull(arrValid);

      setInutError(validateInut.errorsValidation);

      if (validateInut.error) {
        return notify("Campos obrigatórios não preenchidos.");
      }

      if (
        !single &&
        MaskService.removeMaskDecimal(initialNumber) >
          MaskService.removeMaskDecimal(finalNumber)
      ) {
        validateInut.errorsValidation.initialNumber = "Valor Inválido";
        validateInut.errorsValidation.finalNumber = "Valor Inválido";
        validateInut.error = true;
        setInutError(validateInut.errorsValidation);
        return notify("Valor Inicial não pode ser superior ao valor final.");
      }

      if (justify.length < 15) {
        validateInut.errorsValidation.justify =
          "Justificativa deve ter no mínimo 15 caracteres";
        setInutError(validateInut.errorsValidation);
        return notify("Justificativa deve ter no mínimo 15 caracteres");
      }

      const arrNums = [];
      const nfNumeros = [];

      if (single) {
        selectedNotes.forEach((element) => {
          nfNumeros.push(parseInt(element.numero));
          const itemSeries = (listSeries || []).find(
            (serie) =>
              parseInt(serie?.serieNumber) === parseInt(element.serie) &&
              (serie?.model || "").toString() ===
                (element.modelo || "").toString()
          );

          if (!itemSeries || element.status === "R") {
            notify(
              `Nota de Número ${element.numero} com Série ${element.serie} não pode ser inutilizada pois a série correspondente não está previamente cadastrada no sistema ou porque ja fora transmitida e autorizada.`
            );
          } else {
            arrNums.push({
              numero: parseInt(element.numero),
              idempresa: parseInt(queryParams.id),
              idusuario: parseInt(queryParams.usuario_id),
              series_id: itemSeries.id,
              motivo: justify,
              modelo: element.modelo.toString(),
            });
          }
        });
      } else {
        for (
          let i = MaskService.removeMaskDecimal(initialNumber);
          i <= MaskService.removeMaskDecimal(finalNumber);
          i++
        ) {
          arrNums.push({
            numero: i,
            idempresa: parseInt(queryParams.id),
            idusuario: parseInt(queryParams.usuario_id),
            series_id: series.id,
            motivo: justify,
            modelo: (model?.value).toString(),
          });
          nfNumeros.push(i);
        }
      }

      if (single && !arrNums.length) {
        return notify(
          "Não foi possível inutilizar nenhuma numeração da(s) nota(s) selecionada(s)"
        );
      }

      const isSameModel = arrNums.every(
        (item, _, array) => item.modelo === array[0].modelo
      );

      if (!isSameModel) {
        return notify("Não é possível inutilizar modelos diferentes.");
      }

      setMainLoading(true);

      let orWhere = [];
      arrNums.forEach((element) => {
        orWhere.push({
          numero: element.numero,
        });
      });

      const callbackNumbers = await findUnusableNumbers({
        empresa_cnpj: queryParams.empresa_cnpj,
        orWhere: orWhere,
        where: {
          idempresa: parseInt(queryParams.id),
          modelo: arrNums[0].modelo,
        },
        isSameOrWhere: true,
      });

      if (!callbackNumbers.success) {
        return notify("Erro na inutilização.");
      }

      let saves = [];
      const numbersUnusable = [];

      if (callbackNumbers.data.length) {
        arrNums.forEach((element) => {
          const validItem = callbackNumbers.data.find(
            (num) =>
              parseInt(num.numero) === parseInt(element.numero) &&
              parseInt(num.series_id) === parseInt(element.series_id) &&
              parseInt(num.modelo) === parseInt(element.modelo)
          );
          if (validItem) {
            numbersUnusable.push(validItem);
          } else {
            saves.push(element);
          }
        });
      } else {
        saves = arrNums;
      }

      if (saves.length) {
        const saveBody = {
          numeroinutilizado: saves,
        };

        const callbackSaveNumInut = await saveNumber(
          queryParams.empresa_cnpj,
          saveBody
        );

        if (!callbackSaveNumInut.success) {
          return notify("Erro ao Salvar a Inutilização");
        }

        callbackSaveNumInut.data.forEach((element) => {
          numbersUnusable.push(element);
        });

        if (nfNumeros.length) {
          const callbackNfeLoteNf = await aprovarLotePorNumeroNotaFiscal(
            queryParams.empresa_cnpj,
            {
              notaFiscal: { numero: nfNumeros, modelo: arrNums[0].modelo },
            }
          );
          if (!callbackNfeLoteNf.success) {
            return notify("Erro ao Atualizar a Inutilização na nota");
          }
        }

        notify(
          "Inutilização Salva no Banco de Dados. Comunicando-se com a sefaz...",
          true,
          "success"
        );
      }

      const idsUnusable = [];
      numbersUnusable.sort((a, b) => {
        return parseInt(a.numero) - parseInt(b.numero);
      });

      numbersUnusable.forEach((itemUnusable) => {
        idsUnusable.push(itemUnusable.id);
      });

      if (!idsUnusable.length) {
        return notify("Erro ao selecionar numeração para inutilização.");
      }

      const sendBody = {
        numeroinutilizado: {
          ids: idsUnusable,
          model: arrNums[0].modelo,
          single,
        },
      };

      if (hasSalesInNfe)
        sendBody.numeroinutilizado.situation = saleSituation.id;

      const callbackSend = await sendNumbers(
        queryParams.empresa_cnpj,
        sendBody
      );

      if (!callbackSend?.success) {
        if (callbackSend?.message) {
          return notify(callbackSend.message);
        }

        return notify("Erro ao Inutilizar Numeração");
      }

      clearInutilizacaoNfe();
      return notify("Numero(s) Inutilizado(s) com sucesso", true, "success");
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleDownloadArchives = async (notes = [], params = {}) => {
    if (params.allSelected) {
      const callback = await find({
        empresaCnpj: queryParams.empresa_cnpj,
        path: "nf/notasfiscais/v1",
        include: "vendas,notasfiscaisarchives,nfelotenf",
        fields: { "nf.notafiscal": "id" },
        where: params.queryWhere,
        orWhere: params.queryOrWhere,
        between: params.queryBetween,
        perPage: 1000,
      });

      if (callback && callback.success) {
        notes = callback.data;
      }
    }

    if (!(notes || []).length)
      return notify("Nenhuma Nota foi selecionada.", true, "warning");
    const bodyRequest = {
      singleFolder: singleFolder,
      xml: {
        base: downloadXml,
        return: downloadXmlReturn && hasCanceled,
      },
      danfe: {
        default: downloadDanfePdf,
        tag: false,
      },
      cce: {
        base: downloadCCe,
        return: false,
      },
      idsNfe: notes.map((note) => note.id),
    };

    try {
      setMainLoading(true);
      const result = await downloadArchives({
        empresa_cnpj: queryParams.empresa_cnpj,
        body: bodyRequest,
      });

      if (!result?.success) return notify("Erro ao fazer download!");

      instantDownload(result?.data?.archive_base64, "NFeArquivos.zip");
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }

    return true;
  };

  const handleResendInutilization = async (unusedNumber) => {
    try {
      if (queryParams.empresa_cnpj?.endsWith("_democ")) {
        return notify("Operação não permitida em ambiente de treinamento.");
      }

      setMainLoading(true);

      const serie = listSeries.find((s) => s.id === unusedNumber.series_id);
      const where = {
        idempresa: parseInt(queryParams.id),
        numero: unusedNumber.numero,
        serie: serie.number || unusedNumber.series_id,
      };

      const nfeListCallback = await findNotas(
        queryParams.empresa_cnpj,
        null,
        "vendas,contasreceber",
        where
      );

      if (!nfeListCallback.success)
        return notify(
          "Erro ao buscar notas que possam estar vinculadas a numeração informada"
        );

      if (nfeListCallback.data.length) {
        const nfToUnused = nfeListCallback.data.find(
          (nf) =>
            nf.numero === unusedNumber.numero &&
            unusedNumber?.series?.models?.modelo === nf.modelo
        );

        if (nfToUnused?.tipo_montagem === "V") {
          const copy = [...selectedItem];
          copy.push(nfToUnused);

          setSelectedItem(copy);
          setTabIndexUnunsed(0);
          setJustify(unusedNumber.motivo);

          return notify(
            "Selecione a situação de venda para os títulos em aberto",
            true,
            "warning"
          );
        }
      }

      const sendBody = {
        numeroinutilizado: {
          ids: [unusedNumber.id],
          single: true,
        },
      };

      const callbackSend = await sendNumbers(
        queryParams.empresa_cnpj,
        sendBody
      );

      if (!callbackSend.success) {
        if (callbackSend?.message) {
          return notify(callbackSend?.message);
        }

        return notify("Erro ao tentar retransmitir inutilização");
      }

      return notify("Numero inutilizado com sucesso", true, "success");
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const clearInutilizacaoNfe = () => {
    setSeries(null);
    setInitialNumber(0);
    setFinalNumber(0);
    setInutError({});
    setJustify("");
  };

  const handleVerifyNfeStatus = (data) => {
    const finalValues = [];

    data?.forEach((dataStatus) => {
      if (optionsStatus?.value === "R") {
        if (
          dataStatus?.status === "R" &&
          ((dataStatus?.nfelotenf?.length &&
            dataStatus?.nfelotenf[0]?.st_aprovada) ||
            dataStatus?.nfeprotocolo)
        ) {
          finalValues.push(dataStatus);
        }
      } else {
        finalValues.push(dataStatus);
      }
    });

    return finalValues;
  };

  const handleCloneNfe = useCallback(
    async ({ id, regime }) => {
      await Swal.fire({
        icon: "question",
        text: "Confirma a clonagem desta nota fiscal?",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (queryParams.crt !== regime) {
            await Swal.fire({
              icon: "info",
              text: "Identificamos que o regime tributário da nota clonada difere do regime tributário atual de sua empresa. Recomendamos revisar todos os itens da nota fiscal para garantir a conformidade com o regime tributário atual.",
              confirmButtonText: "OK",
              showConfirmButton: true,
            });
          }
          push(`/financeiro/nfe/emissao`, { id: id, operation: "clone" });
        }
      });
    },
    [push, queryParams.crt]
  );

  const handleGetDuplicateData = useCallback(
    async ({ setDuplicateData = () => {}, nfeId = null }) => {
      try {
        if (!nfeId)
          return notify(
            "Não foi possível identificar a nota fiscal. Se o problema persistir entre em contato com o time de suporte!"
          );

        setMainLoading(true);
        const callback = await getDuplicate({ nfeId: nfeId });

        if (!callback.success)
          return notify(
            "Não foi possível buscar as informações. Se o problema persistir entre em contato com o time de suporte!"
          );

        const selectableData = (callback.data || []).map((item) => ({
          ...item,
          notSelectable: !item?.is_valid_duplicate,
        }));

        setDuplicateData(selectableData);
      } catch (error) {
        console.error("Get Duplicate Error: ", error);
        notify(
          "Não foi possível buscar as informações. Se o problema persistir entre em contato com o time de suporte!"
        );
      } finally {
        setMainLoading(false);
      }
    },
    [setMainLoading]
  );

  const handleOpenDownloadBilletFile = useCallback(
    async ({ crId = [] }) => {
      try {
        if (!Array.isArray(crId) || !crId.length)
          return notify("Não foi possível realizar o download do boleto.");

        setMainLoading(true);

        const callback = await getCrBankBillet({
          account_ids: crId,
        });

        if (!callback.success)
          return notify("Não foi possível realizar o download.");

        const foundedBankBillet =
          Array.isArray(callback.data) && callback.data[0]?.objectBase64
            ? callback.data[0]?.objectBase64
            : null;

        if (!foundedBankBillet)
          return notify(
            "Não foi possível realizar o download. Boleto não encontrado."
          );

        const blob = b64toBlob(foundedBankBillet, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      } catch (error) {
        console.error("Download Bank Billet Error: ", error);
        notify("Não foi possível realizar o download do boleto.");
      } finally {
        setMainLoading(false);
      }
    },
    [setMainLoading]
  );

  const handleDownloadMercantileDuplicate = useCallback(
    async ({ nfeId = null, selectedItems = [] }) => {
      try {
        if (!Array.isArray(selectedItems) || !selectedItems.length)
          return notify("Selecione ao menos um item.", true, "warning");

        if (!nfeId)
          return notify(
            "Não foi possível identificar a nota fiscal. Se o problema persistir entre em contato com o time de suporte!"
          );

        setMainLoading(true);

        const selectedIds = selectedItems.map((item) => item.id);

        const callback = await duplicatePrint({
          nfeId,
          duplicateIds: selectedIds,
        });

        if (!callback.success)
          return notify("Não foi possível realizar o download.");

        const foundedFile = callback?.data?.file_base64 || null;

        if (!foundedFile)
          return notify(
            "Não foi possível realizar o download. Falha ao obter o arquivo!"
          );

        const blob = b64toBlob(foundedFile, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      } catch (error) {
        console.error("Download Duplicate Error: ", error);
        notify("Não foi possível realizar o download.");
      } finally {
        setMainLoading(false);
      }
    },
    [setMainLoading]
  );

  return {
    loading,
    handleDownloadMultiplesDanfes,
    handleGetDataTable,
    handleDownloadDanfe,
    handleDownloadXmlNota,
    handleCancelNfe,
    handleSaveCC,
    handleHistoryCC,
    handleSendEmail,
    handleVerifyNfeStatus,
    handleDownloadCartaCorrecao,
    handleInutilizarNumNfe,
    handleDownloadArchives,
    handleResendInutilization,
    clearInutilizacaoNfe,
    handleCloneNfe,
    handleGetDuplicateData,
    handleOpenDownloadBilletFile,
    handleDownloadMercantileDuplicate,
  };
}
